import React from "react";
import EnterpriseNeedsField from "../../../../../components/Billing/EnterpriseNeedsField";
import { SUPPORT_EMAIL } from "../../../../../components/Billing/billingCodes";

// Enterprise is priced around what the organization needs, so the review step
// asks it to say what that is. What it writes goes to our team with the request
// (components/Billing/enterpriseRequest.js), the way the website's contact form
// reaches us.
function EnterpriseContact({ needs, onChange }) {
   return (
      <section className="plan-information-review enterprise-contact-review">
         <div>
            <h2>Tell us what you need</h2>
            <p className="enterprise-contact-review__text">
               Write the specifications of the plan you want: how many workspaces, the projects in
               each, the users, and anything else you need. When you press Request Enterprise, we send
               it to our team and email you a confirmation. We agree the prices and limits with you,
               and your plan is then ready to take up from your billing page.
            </p>
            <EnterpriseNeedsField value={needs} onChange={onChange} label={null} />
            {/* The address as text, to copy: the field above is how the request
                reaches us, and a mail link depends on the mail app of whoever
                clicks it. */}
            <p className="enterprise-contact-review__text enterprise-contact-review__alt">
               You can also write to us at{" "}
               <strong className="enterprise-contact-review__email">{SUPPORT_EMAIL}</strong>.
            </p>
         </div>
      </section>
   );
}

export { EnterpriseContact };
